import axios from 'axios';
import { EnvironmentNames } from 'enuns/EnvironmentNames';

export interface IEnpointApis {
  assessor: string;
  notificacao: string;
  evento: string;
  pessoa: string;
  messenger: string;
}

export interface IWebsockets {
  wsAssembleia: string;
}

export interface IEnpointWSO2Auth {
  authUrl: string;
  tokenUrl: string;
  wso2LogoutUrl: string;
  identityClientId: string;
  redirectUrl: string;
  logofRedirectUrl: string;
}

export interface IAuthAssociado {
  authority: string;
  redirect_uri: string;
  post_logout_redirect_uri: string;
  client_id: string;
  response_type: string;
  metadata: {
    issuer: string;
    authorization_endpoint: string;
    token_endpoint: string;
    introspection_endpoint: string;
    userinfo_endpoint: string;
    end_session_endpoint: string;
    jwks_uri: string;
    check_session_ifram: string;
  };
}

export interface IApis {
  environment: EnvironmentNames;
  isOffline: boolean;
  gtag: boolean;
  handtalk: boolean;
  apis: IEnpointApis;
  websockets: IWebsockets;
  auth: IEnpointWSO2Auth;
  authAssociado: IAuthAssociado;
}

let loadedEnvironment: IApis;

export const getAssembleiasAssessorEndpoint = (version: number = 1) => {
  return loadedEnvironment && loadedEnvironment.apis ? `${loadedEnvironment.apis.assessor}/v${version}/` : '';
};

export const getAssembleiasAssociadoEndpoint = (version: number = 1) => {
  return loadedEnvironment && loadedEnvironment.apis ? `${loadedEnvironment.apis.pessoa}/v${version}/` : '';
};

export const getAssembleiasNotificacaoEndpoint = (version: number = 1) => {
  return loadedEnvironment && loadedEnvironment.apis ? `${loadedEnvironment.apis.notificacao}/v${version}/` : '';
};

export const getAssembleiasAssociadoMessengerEndpoint = (version: number = 1) => {
  return loadedEnvironment && loadedEnvironment.apis ? `${loadedEnvironment.apis.messenger}/v${version}/` : '';
};

export const getAssembleiasAssociadoEventoEndpoint = (version: number = 1) => {
  return loadedEnvironment && loadedEnvironment.apis ? `${loadedEnvironment.apis.evento}/v${version}/` : '';
};

export const getWSAssembleiasEndpoint = (): string => {
  return loadedEnvironment && loadedEnvironment.websockets ? `${loadedEnvironment.websockets.wsAssembleia}` : '';
}

export const getApiEndpoint = (api: keyof IEnpointApis, version?: number) => {
  switch (api) {
    case 'assessor':
      return getAssembleiasAssessorEndpoint(version);
    case 'pessoa':
      return getAssembleiasAssociadoEndpoint(version);
    case 'notificacao':
      return getAssembleiasNotificacaoEndpoint(version);
    case 'messenger':
      return getAssembleiasAssociadoMessengerEndpoint(version);
    case 'evento':
      return getAssembleiasAssociadoEventoEndpoint(version);
    default:
      return;
  }
};

export const loadEnvironments = async () => {
  try {
    const response = await axios.get<IApis>('assets/environments/default.json');
    loadedEnvironment = response.data;
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getApis = () => {
  return loadedEnvironment;
};